//@ts-check
import React from 'react';
import Formatter from '../../../formatter';
/**
 * @typedef { object } JobTicketModel Data model returned by the sever representing an EmailTicket.
 * @property { number } Id Ticket unique identifier.
 * @property { string } Subject
 * @property { 'Email' | 'Print' | 'Sms' } QueueType
 * @property { string } JobId
 *
 * */

var getIcon = function getIcon(data) {
  return getType(data).toLowerCase();
};

var getType = function getType(data) {
  return data.QueueType ? data.QueueType.toLowerCase() : 'Ticket';
};
/**@type {import('../types').DataType<JobTicketModel>} */


var JOB_TICKET_DATA_TYPE = {
  data: {
    url: '/backend/queuejobtickets',
    itemUrl: '/backend/queuejobtickets/{id}',
    deleteItemUrl: '/backend/queuejobtickets/{id}',
    dataKey: 'emailTickets',
    idKeyProp: 'Id'
  },
  placeholders: {
    type: getType,
    label: function label(data) {
      return data.Subject;
    },
    icon: getIcon
  },
  columns: [{
    id: 'Subject',
    formatter: function formatter(_ref) {
      var data = _ref.data;
      return React.createElement(Formatter.DataLink, {
        dataType: "jobTicket",
        data: data,
        app: "Communications",
        value: "/ticket/7393",
        openInNewTab: true
      });
    },
    serverSort: false,
    inMemorySort: false
  }],
  thumbnail: {
    text: function text(data) {
      return data.Subject;
    },
    icon: getIcon
  },
  contextMenu: [{
    type: 'open'
  }, 'separator', {
    type: 'delete'
  }]
};
export default JOB_TICKET_DATA_TYPE;